module.exports = __webpack_public_path__ + "static/img/A106.48ec8820.jpg";